import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'vds-sidebar-teaser-small',
  styleUrl: 'vds-sidebar-teaser-small.scss',
  shadow: true,
})
export class VdsSidebarTeaserSmall {

  /**
   * Headline
   * Mandatory: yes
   */
  @Prop() headline = '';

  /**
   * Content
   * Mandatory: yes
   */
  @Prop() copy = '';

  render() {
    return (
      <Host>
        <div class="relative bg-white box-border border-2 border-grey-lighter rounded-[5px]">
          <div class="p-[30px]">
            <h3 class="font-heavy text-h3-mobile sm:text-h3-tablet lg:text-h3-desktop text-grey uppercase mb-[20px] break-words" innerHTML={ this.headline }></h3>
            <span class="block text-sidebar-mobile sm:text-sidebar-desktop text-grey">{ this.copy }</span>
          </div>
          <div class="px-[30px] pb-[30px] break-words">

            <slot name="cta"></slot>

          </div>
        </div>
      </Host>
    );
  }

}
